<apex-client-addon-breadcrumb
  [apartment]="apartment"
  [cart]="null">
</apex-client-addon-breadcrumb>

<ng-container *ngIf="loading">
  <div class="df jcc amt apt">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-container>

<ng-container *ngIf="error && !loading">
  <div class="error-container amt apt">
    <mat-icon color="warn">error_outline</mat-icon>
    <p class="mat-body-1">{{ error }}</p>
    <button
      mat-raised-button
      (click)="back()">
      <T str="Go Back"></T>
    </button>
  </div>
</ng-container>

<!-- Gallery Section -->
<section class="package-gallery amt">
  <div class="df c">
    <apex-file-usage-preview
      self="addon-package"
      [selfId]="packageId"
      name="gallery"
      [title]="'Gallery' | translate">
    </apex-file-usage-preview>
  </div>
  <apex-file-usage
    self="addon-package"
    [selfId]="packageId"
    name="gallery"
    [title]="'Gallery' | translate"
    [disabled]="true"
    [disableToolsAsClient]="true"
    view="Single">
  </apex-file-usage>
</section>

<div
  class="package-detail-container"
  *ngIf="package && !loading && !error">
  <!-- Package Header -->
  <header class="package-header amt">
    <h1 class="mat-headline-3 rm">{{ package.title }}</h1>
  </header>

  <!-- Description Section -->
  <section class="package-description amt">
    <p class="mat-body-1 description-text">{{ package.description }}</p>
  </section>

  <!-- Pricing Section -->
  <section class="package-pricing amt">
    <div class="price-display mat-elevation-z1">
      <div class="price-label mat-caption">
        <T str="Package Price"></T>
      </div>
      <div class="price-value mat-headline-4">
        {{ packagePrice | apexCurrency: 'NOK' : '' }}
      </div>
    </div>
  </section>

  <!-- Included Addons Section -->
  <section
    class="package-addons amt"
    *ngIf="package.Addons?.length">
    <h2 class="mat-headline-5 rm amb">
      <T str="Included Addons"></T>
    </h2>
    <div class="addons-list">
      <mat-card
        *ngFor="let addon of package.Addons"
        class="addon-item">
        <mat-card-content>
          <div class="addon-item-content">
            <mat-icon class="addon-check-icon">check_circle</mat-icon>
            <div class="addon-info">
              <h3 class="mat-subtitle-1 rm">{{ addon.name }}</h3>
              <p
                class="mat-body-2 addon-description"
                *ngIf="addon.description">
                {{ addon.description }}
              </p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </section>

  <!-- Order Section -->
  <section class="package-order amt apt">
    <mat-divider class="amb"></mat-divider>
    <div class="order-actions amt">
      <button
        mat-stroked-button
        (click)="back()"
        [disabled]="ordering">
        <T str="Back"></T>
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="orderPackage()"
        [disabled]="ordering">
        <mat-spinner
          *ngIf="ordering"
          diameter="20"
          class="button-spinner"></mat-spinner>
        <span *ngIf="!ordering">
          <T str="Order Package"></T>
        </span>
        <span *ngIf="ordering">
          <T str="Creating Order..."></T>
        </span>
      </button>
    </div>
  </section>
</div>
